import { TextComponent } from '../../../../uiComponent/TextComponent/TextComponent';

export const MTPRTitleComponent = () => (
  <TextComponent size="large" bold>
    MTPR (Monthly Treatment Plan Review)
  </TextComponent>
);
